"use client";

import { useRef } from "react";
import { Clock, MapPin, Phone } from "lucide-react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
gsap.registerPlugin(useGSAP, ScrollTrigger);
export default function ServiceArea() {
  const container = useRef<HTMLDivElement>(null);
  const communities = ["Atlanta", "Marietta", "Gwinnett", "Alpharetta", "Roswell", "Sandy Springs", "Buckhead", "Decatur", "Duluth", "Johns Creek", "Brookhaven", "Peachtree Corners"];
  useGSAP(() => {
    const el = container.current;
    if (!el) return;
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".sa-map", {
        x: -24
      });
      gsap.to(".sa-map", {
        opacity: 1,
        x: 0,
        duration: 0.7,
        ease: "power3.out",
        scrollTrigger: {
          trigger: el,
          start: "top 80%",
          once: true
        }
      });
      gsap.set(".sa-reveal", {
        y: 16
      });
      gsap.to(".sa-reveal", {
        opacity: 1,
        y: 0,
        duration: 0.6,
        stagger: 0.1,
        ease: "power3.out",
        scrollTrigger: {
          trigger: el,
          start: "top 80%",
          once: true
        }
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".sa-map", ".sa-reveal"], {
        opacity: 1,
        x: 0,
        y: 0
      });
    });
    const refresh = () => ScrollTrigger.refresh();
    requestAnimationFrame(refresh);
    if (document.readyState === "complete") refresh();else window.addEventListener("load", refresh, {
      once: true
    });
    document.fonts?.ready.then(refresh);
  }, {
    scope: container
  });
  return <section data-section-id="32659" id="serviceareamap" data-nav="light" className="bg-background py-32 md:py-44">
      <div ref={container} className="mx-auto max-w-[1360px] px-5 md:px-10">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-10">
          {}
          <div className="sa-map lg:col-span-7" style={{
          opacity: 0
        }}>
            <div className="relative w-full overflow-hidden rounded-lg border border-border" style={{
            height: "620px",
            maxHeight: "70vh"
          }}>
              {}
              <div className="absolute inset-0" style={{
              backgroundColor: "var(--bone)"
            }} />

              {}
              <svg viewBox="0 0 800 620" preserveAspectRatio="xMidYMid slice" className="absolute inset-0 h-full w-full" aria-hidden="true">
                {}
                <path d="M 120 0 Q 180 120 140 240 T 200 480 Q 220 560 260 620" stroke="var(--rule)" strokeWidth="8" fill="none" opacity="0.35" />
                <path d="M 620 0 Q 580 100 640 220 T 600 460 Q 580 540 620 620" stroke="var(--rule)" strokeWidth="6" fill="none" opacity="0.3" />

                {}
                <ellipse cx="200" cy="180" rx="180" ry="120" fill="var(--primary)" opacity="0.05" />
                <ellipse cx="650" cy="450" rx="220" ry="140" fill="var(--primary)" opacity="0.06" />
                <ellipse cx="450" cy="520" rx="160" ry="90" fill="var(--navy)" opacity="0.04" />

                {}
                <path d="M 0 310 L 400 310 L 500 280 L 800 280" stroke="var(--navy)" strokeWidth="2.5" fill="none" opacity="0.65" />
                <path d="M 400 0 L 400 310 L 380 500 L 380 620" stroke="var(--navy)" strokeWidth="2.5" fill="none" opacity="0.65" />
                <path d="M 0 460 L 380 460 L 500 440 L 800 440" stroke="var(--navy)" strokeWidth="1.8" fill="none" opacity="0.5" />
                <path d="M 200 0 L 220 200 L 400 310" stroke="var(--navy)" strokeWidth="1.5" fill="none" opacity="0.4" />
                <path d="M 400 310 L 560 380 L 700 620" stroke="var(--navy)" strokeWidth="1.8" fill="none" opacity="0.5" />
                <path d="M 600 0 L 560 150 L 500 280" stroke="var(--navy)" strokeWidth="1.5" fill="none" opacity="0.4" />
                <path d="M 100 100 L 300 200 L 400 310" stroke="var(--navy)" strokeWidth="1.2" fill="none" opacity="0.35" />

                {}
                <circle cx="400" cy="310" r="270" fill="none" stroke="var(--navy)" strokeWidth="1.5" strokeDasharray="4 6" opacity="0.5" />
                {}
                <circle cx="400" cy="310" r="150" fill="none" stroke="var(--navy)" strokeWidth="1.5" strokeDasharray="4 6" opacity="0.6" />

                {}
                <text x="400" y="150" textAnchor="middle" fill="var(--navy)" fontSize="10" fontWeight="600" letterSpacing="2" opacity="0.75">
                  20 MI
                </text>
                <text x="400" y="30" textAnchor="middle" fill="var(--navy)" fontSize="10" fontWeight="600" letterSpacing="2" opacity="0.75">
                  40 MI
                </text>

                {}
                <g fill="var(--foreground)" opacity="0.55">
                  <circle cx="300" cy="220" r="3" />
                  <circle cx="510" cy="290" r="3" />
                  <circle cx="380" cy="180" r="3" />
                  <circle cx="290" cy="420" r="3" />
                  <circle cx="500" cy="410" r="3" />
                  <circle cx="560" cy="220" r="3" />
                  <circle cx="240" cy="340" r="3" />
                  <circle cx="540" cy="360" r="3" />
                </g>

                {}
                <g fill="var(--foreground)" fontSize="10" fontWeight="500" opacity="0.7">
                  <text x="310" y="212">Marietta</text>
                  <text x="520" y="282">Duluth</text>
                  <text x="390" y="172">Roswell</text>
                  <text x="300" y="412">Decatur</text>
                  <text x="510" y="402">Gwinnett</text>
                  <text x="570" y="212">Johns Creek</text>
                  <text x="250" y="332">Buckhead</text>
                  <text x="550" y="352">Alpharetta</text>
                </g>

                {}
                <g>
                  <circle cx="400" cy="310" r="18" fill="var(--primary)" opacity="0.18" />
                  <circle cx="400" cy="310" r="12" fill="var(--primary)" stroke="var(--bone)" strokeWidth="2.5" />
                  <text x="400" y="345" textAnchor="middle" fill="var(--foreground)" fontSize="13" fontWeight="700" letterSpacing="1">
                    ATLANTA
                  </text>
                </g>
              </svg>

              {}
              <div className="absolute bottom-5 left-5 flex flex-col gap-2 rounded-md border border-border bg-background/90 px-4 py-3 backdrop-blur-sm">
                <div className="flex items-center gap-2">
                  <span className="inline-block h-3 w-3 rounded-lg" style={{
                  backgroundColor: "var(--primary)"
                }} />
                  <span className="text-[11px] font-semibold uppercase" style={{
                  letterSpacing: "0.14em",
                  color: "var(--foreground)"
                }}>
                    HQ Hub
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="inline-block h-3 w-3 rounded-lg border border-dashed" style={{
                  borderColor: "var(--primary)"
                }} />
                  <span className="text-[11px] font-semibold uppercase" style={{
                  letterSpacing: "0.14em",
                  color: "var(--muted-foreground)"
                }}>
                    Service Zone
                  </span>
                </div>
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-5">
            {}
            <div className="sa-reveal flex items-center gap-2" style={{
            opacity: 0
          }}>
              <span className="inline-block h-3 w-px" style={{
              backgroundColor: "var(--primary)"
            }} />
              <span className="text-xs font-semibold uppercase" style={{
              letterSpacing: "0.22em",
              color: "var(--primary)"
            }}>
                Service Coverage
              </span>
              <span className="inline-block h-3 w-px" style={{
              backgroundColor: "var(--primary)"
            }} />
            </div>

            {}
            <h2 className="sa-reveal mt-8 font-default font-bold uppercase text-foreground" style={{
            opacity: 0,
            fontSize: "clamp(2.5rem, 6vw, 5rem)",
            lineHeight: "0.96",
            letterSpacing: "-0.005em"
          }}>
              Greater Atlanta.
              <br />
              Expert Care.
            </h2>

            {}
            <p className="sa-reveal mt-8 text-foreground/85" style={{
            opacity: 0,
            fontSize: "clamp(1.0625rem, 1.25vw, 1.25rem)",
            lineHeight: "1.6",
            maxWidth: "40ch"
          }}>
              Handy Heroes connects homeowners across greater Atlanta with independent
              local repair specialists. Vetted pros cover major communities,
              helping you troubleshoot and repair broken refrigerators, ovens,
              washers, dryers, and dishwashers.
            </p>

            {}
            <div className="sa-reveal mt-10" style={{
            opacity: 0
          }}>
              <div className="flex items-center gap-2">
                <span className="inline-block h-3 w-px" style={{
                backgroundColor: "var(--primary)"
              }} />
                <span className="text-xs font-semibold uppercase" style={{
                letterSpacing: "0.22em",
                color: "var(--primary)"
              }}>
                  Support Center
                </span>
                <span className="inline-block h-3 w-px" style={{
                backgroundColor: "var(--primary)"
              }} />
              </div>

              <div className="mt-5 space-y-3 text-foreground">
                <div className="flex items-start gap-3">
                  <MapPin className="mt-1 shrink-0" size={16} style={{
                  color: "var(--primary)"
                }} />
                  <div className="text-base leading-relaxed">
                    <div>Handy Heroes Network</div>
                    <div>Atlanta, Georgia</div>
                    <div className="text-muted-foreground">
                      Local pro matching across metro Atlanta
                    </div>
                  </div>
                </div>

                <div className="flex items-center gap-3">
                  <Phone className="shrink-0" size={16} style={{
                  color: "var(--primary)"
                }} />
                  <span className="text-base">{"(470) 847-9076"}</span>
                </div>

                <div className="flex items-center gap-3">
                  <Clock className="shrink-0" size={16} style={{
                  color: "var(--primary)"
                }} />
                  <span className="text-base">
                    Mon–Fri: 7am–7pm &nbsp;·&nbsp; Sat: 8am–4pm
                  </span>
                </div>
              </div>
            </div>

            {}
            <div className="sa-reveal mt-10" style={{
            opacity: 0
          }}>
              <div className="flex items-center gap-2">
                <span className="inline-block h-3 w-px" style={{
                backgroundColor: "var(--primary)"
              }} />
                <span className="text-xs font-semibold uppercase" style={{
                letterSpacing: "0.22em",
                color: "var(--primary)"
              }}>
                  Areas Covered
                </span>
                <span className="inline-block h-3 w-px" style={{
                backgroundColor: "var(--primary)"
              }} />
              </div>

              <ul className="mt-5 grid grid-cols-1 gap-x-6 gap-y-3 sm:grid-cols-2">
                {communities.map((name, i) => <li key={name} data-index={i} className="flex items-center gap-3 text-foreground/90">
                    <span className="inline-block h-px w-1.5 shrink-0" style={{
                  backgroundColor: "var(--primary)"
                }} />
                    <span className="text-[15px]">{name}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}